import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getMaterialCategoriesData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-category/`, data);
        return await response.data;
    } catch (error) {
        console.log("getMaterialCategories - error", error)
        return handleApiError(error)
    }
}

export const getMaterialCategoryDataById = async (categoryId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/material-category/${categoryId}`);
        return await response.data;
    } catch (error) {
        console.log("getMaterialCategoryById - error", error)
        return handleApiError(error)
    }
}

export const addMaterialCategoryData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-category/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addMaterialCategory - error", error)
        return handleApiError(error)
    }
}

export const getAllMaterialCategories = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-category/allCategories`, data)
        return await response.data;
    } catch (error) {
        console.log("getAllMaterialCategories - error", error)
        return handleApiError(error)
    }
}

export const validateMaterialCategory = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-category/validate`, data);
        return await response.data
    } catch (error) {
        console.log("validateMaterialCategory - error", error)
        return handleApiError(error)
    }
}

export const validateMaterialCategoryUsingParser = async (data) => {
    const headers = {
        ...axios.defaults.headers.common,
        "x-api-key": "e7d2bf40-2fb3-4f3d-96b4-10fe6d5f6c87"
    }
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/material-category/validate-material-category`, data);
        // const response = await axios.post(`https://portal.procmart.com/api/core/material-category/predict-category`, data, headers)
        return await response.data;
    } catch (error) {
        console.log("validateMaterialCategoryUsingParser - error", error)
        return handleApiError(error)
    }
}